var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1007.2 501.8",
    style: {
      enableBackground: "new 0 0 1007.2 501.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;enable-background:new    ;}\n\t.st1{fill:#F5F5F5;}\n\t.st2{fill:#EDEDF4;}\n\t.st3{fill:#6C63FF;}\n\t.st4{fill:#1A2246;}\n\t.st5{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 503.6,
    cy: 364.1,
    rx: 481.8,
    ry: 137.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e2331fcb-09a1-43a6-a836-11e9ed08f05e"
  }, /*#__PURE__*/React.createElement("title", null, "street_food"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "867,379.3 819.2,375.7 189.8,375.7 189.8,283.5 867,283.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.3,47.7H142V23.4c0-9.4,7.6-17,17-17l0,0h7.3c9.4,0,17,7.6,17,17l0,0V47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M892.5,239.2v140.7l-46.2-0.6c0-1,0.1-2,0.1-2.9c0-50.3-40.7-91-91-91s-91,40.7-91,91l0,0c0,0.2,0,0.4,0,0.6 l-46.1-0.6H379.5c0-3.3-0.2-6.7-0.6-10c-0.2-1.6-0.4-3.2-0.7-4.7c-0.6-4-1.6-8-2.7-11.9c-0.5-1.6-1-3.2-1.6-4.7 c-1.5-4.1-3.3-8-5.3-11.8c-0.9-1.6-1.8-3.2-2.7-4.7c-2.6-4.2-5.5-8.1-8.7-11.8c-1.4-1.6-2.9-3.2-4.4-4.7 c-35.5-35.5-93.1-35.5-128.6,0c-1.5,1.5-3,3.1-4.4,4.7c-3.2,3.7-6.1,7.7-8.7,11.8c-1,1.5-1.9,3.1-2.7,4.7 c-2.1,3.8-3.8,7.8-5.3,11.8c-0.6,1.6-1.1,3.1-1.6,4.7c-1.2,3.9-2.1,7.8-2.7,11.8c-0.3,1.6-0.5,3.1-0.6,4.7 c-0.4,3.3-0.6,6.7-0.6,10h-91V65.5h641.8L812,204.3l79.1,34.3L892.5,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.7,35.9h602.6c13.8,0,25,11.2,25,25v4.6l0,0H106.5l0,0V50.1C106.5,42.3,112.8,35.9,120.7,35.9 C120.7,35.9,120.7,35.9,120.7,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M604.1,35.9H457.5v-5.5c0-15.2,12.3-27.6,27.6-27.6h84.7L604.1,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.5,330.2h60.7c6.1,0,11,4.9,11,11v34.7c0,6.1-4.9,11-11,11h-60.7c-6.1,0-11-4.9-11-11v-34.7 C93.5,335.1,98.4,330.2,104.5,330.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "617.7,375.7 549.1,375.7 549.1,64.9 683.8,64.9 683.8,280  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,332.6h60.7c6.1,0,11,4.9,11,11v34.7c0,6.1-4.9,11-11,11h-60.7c-6.1,0-11-4.9-11-11v-34.7 C92.3,337.5,97.2,332.6,103.3,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881.5,327.8h17.2c7.6,0,13.8,6.2,13.8,13.8v38.5c0,7.6-6.2,13.8-13.8,13.8h-17.2c-7.6,0-13.8-6.2-13.8-13.8 v-38.5C867.6,334,873.8,327.8,881.5,327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M883.8,329h17.2c7.6,0,13.8,6.2,13.8,13.8v38.5c0,7.6-6.2,13.8-13.8,13.8h-17.2c-7.6,0-13.8-6.2-13.8-13.8 v-38.5C870,335.2,876.2,329,883.8,329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584.6,87.9h67.3c8.8,0,16,7.2,16,16V209c0,8.8-7.2,16-16,16h-67.3c-8.8,0-16-7.2-16-16V103.9 C568.6,95.1,575.8,87.9,584.6,87.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649,
    y: 236.8,
    className: "st4",
    width: 13,
    height: 28.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M708.1,107.4v97.9c0,3,2.5,5.5,5.5,5.5l0,0h60.3c3,0,5.5-2.5,5.5-5.5c0-1-0.3-2-0.8-2.9l-60.3-97.9 c-1.6-2.6-5-3.4-7.6-1.8C709.1,103.7,708.1,105.5,708.1,107.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "600.5,87.9 568.6,116.3 568.6,131.1 614.1,87.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "568.6,148.2 568.6,165.3 644.3,87.9 629.5,87.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "728.1,120.4 708.1,148.2 708.1,158.8 734.6,131.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "743.7,148.2 708.1,178.6 708.1,187.2 751.7,158.8  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 288.5,
    cy: 376.3,
    r: 63.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 288.5,
    cy: 376.3,
    r: 35.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 287.9,
    cy: 375.7,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 755.4,
    cy: 376.3,
    r: 63.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 755.4,
    cy: 376.3,
    r: 35.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 756,
    cy: 375.7,
    r: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 278.8,
    className: "st0",
    width: 443.2,
    height: 4.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "884.2,283.5 681.5,283.5 683.8,280 683.8,278.8 884.2,278.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "884.2,263.4 683.8,263.4 683.8,258.7 884.2,258.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "884.2,243.3 683.8,243.3 683.8,238.6 882.8,238.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.9,295.3c-2.8,1.4-5.5,3-8.1,4.7H105.9v-4.7H246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,295.3v4.7H338.2c-2.6-1.7-5.3-3.3-8.1-4.7H549.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.2,311.9c-1.5,1.5-3,3.1-4.4,4.7H105.9v-4.7L224.2,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,311.9v4.7H357.2c-1.4-1.6-2.9-3.2-4.4-4.7L549.1,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,328.4c-1,1.5-1.9,3.1-2.7,4.7H105.9v-4.7H211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,328.4v4.7H368.7c-0.9-1.6-1.8-3.2-2.7-4.7H549.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,345c-0.6,1.6-1.1,3.1-1.6,4.7h-24.6V345H203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,345v4.7H375.6c-0.5-1.6-1-3.2-1.6-4.7H549.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.7,361.5c-0.3,1.6-0.5,3.1-0.6,4.7h-21.2v-4.7H198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.1,361.5v4.7H379c-0.2-1.6-0.4-3.2-0.7-4.7H549.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M488.8,144.1c0,0,11.8,17.7,20.1,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.5,144.1c0,0,11.8,24.8,43.1,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.5,
    y: 70.2,
    transform: "matrix(8.052277e-03 -1 1 8.052277e-03 110.1898 617.2852)",
    className: "st0",
    width: 3.6,
    height: 365.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.555c745223ada415498572af536d6d75.svg";
export { ForwardRef as ReactComponent };